/**
 * Created by ndzak on 4/23/2016.
 */

import Repo from '../repos/Repo';

export default class CategoryRepo extends Repo{

    constructor($auth){
        super($auth, 'premade-categories');
    }

    all(q){
        return super.all(q, "")
    }

    store(data){
        return super.store(data, "")
    }

    update(id, data){
        return super.update(id, data, "")
    }

    get(id){
        return super.get(id, "")
    }
}


// WEBPACK FOOTER //
// ./src/repos/PremadeCategoryRepo.js